import React from 'react';
import useCreativeChat from './useCreativeChat';
import CreativeChatLayout from '../../components/CreativeChatLayout';
import './styles.css';

export default function CreativeChatPage() {
  const {
    creative,
    messages,
    draft,
    setDraft,
    loading,
    sending,
    uploading,
    error,
    scrollRef,
    sendMessage,
    uploadAsset,
    openManualEditor,
    goToContents,
  } = useCreativeChat();

  return (
    <CreativeChatLayout
      creative={creative}
      messages={messages}
      draft={draft}
      setDraft={setDraft}
      loading={loading}
      sending={sending}
      uploading={uploading}
      error={error}
      scrollRef={scrollRef}
      sendMessage={sendMessage}
      uploadAsset={uploadAsset}
      actions={(
        <>
          <button type="button" className="btn btn-primary" onClick={openManualEditor}>Editar Manualmente</button>
          <button type="button" className="btn btn-secondary" onClick={goToContents}>Conteúdos</button>
        </>
      )}
    />
  );
}
